import { render, staticRenderFns } from "./TradeRegistrationForm.vue?vue&type=template&id=18515a94&"
import script from "./TradeRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./TradeRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports